/**
 * Recursive function to get the name of an option
 * @param {object} option - The option object
 * @param {object} options - The options array
 * @param {object} root0 - The root object
 * @param {string} root0.name - The name of the option
 * @param {string} root0.partNumber - The part number of the option
 * @returns {object} The name and part number of the option
 * @example
 * const option = {
 *   id: 1,
 *   name: 'Option 1',
 *   partNumber: '123456',
 * };
 */
const recursiveGetOptionName = (
  option,
  options,
  { name = '', partNumber = '' },
) => {
  if (!options) {
    return { name: '', partNumber: '', found: false };
  }
  let retVal = { name, partNumber, found: false };
  options.forEach((x, index) => {
    if (retVal.found) {
      return retVal;
    }

    const tempPartNumber = `${partNumber ? `${partNumber}_` : ''}${x.option_type === 'folder' ? x.name.toUpperCase() : x.part_number}`;

    const id = option.product_to_option_link_id || option.id;

    if (x.id === id) {
      retVal = {
        name: `${name}.${index}`,
        partNumber: tempPartNumber,
        dependencies: option.dependencies,
        found: true,
      };
    } else if (x.children) {
      retVal = recursiveGetOptionName(option, x.children, {
        name: `${name}.${index}.children`,
        partNumber: tempPartNumber,
      });
    }
    return retVal;
  });
  return retVal;
};

export default recursiveGetOptionName;
